import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

const staffApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const staffApiService = {
  /**
   * Get business dashboard overview for staff/admin
   * @param {string} idToken - LINE ID token for authentication
   * @param {string} date - Date in YYYY-MM-DD format
   * @returns {Promise<Object>} Dashboard overview data
   */
  getDashboardOverview: async (idToken, date) => {
    try {
      const response = await staffApi.get(`/staff/dashboard/overview?date=${date}&idToken=${idToken}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error('Failed to fetch dashboard overview');
    }
  },
};
